import React from 'react';
import { any } from 'prop-types';


export const AuthLayout = ({ children }) => (
  <div>{children}</div>
);

AuthLayout.propTypes = {
  children: any,
};

AuthLayout.defaultProps = {
  children: null,
};



// WEBPACK FOOTER //
// ./src/layouts/auth/component.js